import React from 'react';
import styled from 'styled-components';

const CustomLabelBlock = styled.span`
    display: ${props => props.display || 'block'};
    float: ${props => props.float || 'none'};
    width: ${props => props.width || '100%'};
    height: ${props => props.height || '26px'};
    background-color: ${props => props.bgColor || '#fff'};
    cursor: pointer;
    font-size: ${props => props.fontSize || '14px'};
    vertical-align: ${props => props.vAlign || 'center'};
    color: ${props => props.color || '#111'};
    margin: ${props => props.margin || '0 0'};
`;

const CustomLabel = ({ text, display, width, height,
    bgColor, fontSize, vAlign, color, margin, onClick, float }) => {
    return (
        <CustomLabelBlock
            display={display} width={width} height={height}
            bgColor={bgColor} fontSize={fontSize} vAlign={vAlign} color={color}
            margin={margin} onClick={onClick}
            float={float}>
            {text}
        </CustomLabelBlock>
    );
};

export default CustomLabel;